(() => {
  const normalize = (data) => {
    if (data?.version !== 1 || !Array.isArray(data.works)) return [];
    const seen = new Set();
    const works = data.works.filter((item) => {
      if (!item || !/^\d{1,7}$/.test(item.id) || seen.has(item.id)) return false;
      if (item.url !== 'https://www.acejimki.co.jp/works/detail.php?p=' + item.id) return false;
      if (typeof item.title !== 'string' || !item.title.trim() || item.title.length > 160) return false;
      if (!/^\/pages\/delivery-case-[a-z0-9-]+$/.test(item.pageUrl)) return false;
      if (!Array.isArray(item.photos) || !item.photos.length || item.photos.length > 12) return false;
      if (!item.photos.every((photo) => {
        try { const u = new URL(photo.url); return u.protocol === 'https:' && u.hostname === 'cdn.shopify.com' && /^\/s\/files\/1\/0833\/5844\/9877\/files\/ace-(?:case|workspace)-/.test(u.pathname) && !u.username && !u.password && !u.hash; } catch { return false; }
      })) return false;
      seen.add(item.id);
      return true;
    });
    const official = data.official && typeof data.official === 'object' ? data.official : {};
    Object.keys(official).forEach((id) => {
      const files = official[id];
      if (!/^\d{1,7}$/.test(id) || seen.has(id) || !Array.isArray(files) || !files.length || files.length > 30) return;
      if (!files.every((file) => typeof file === 'string' && /^[^\/\\?#"<>]{1,120}\.(?:jpe?g|png|webp)$/i.test(file))) return;
      seen.add(id);
      const named = data.officialTitles && typeof data.officialTitles[id] === 'string' ? data.officialTitles[id].trim().slice(0, 80) : '';
      const title = named ? named + 'の空間事例' : '事例 ' + id;
      works.push({id, title, official: true, url: 'https://www.acejimki.co.jp/works/detail.php?p=' + id, pageUrl: '', photos: files.map((file, index) => ({url: 'https://www.acejimki.co.jp/upimg/' + encodeURIComponent(file), alt: title + ' 写真' + (index + 1), caption: title + ' 写真' + (index + 1)}))});
    });
    return works;
  };
  const init = async (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'loading';
    const select = root.querySelector('[data-ace-work-select]');
    const status = root.querySelector('[data-work-status]');
    const labels = JSON.parse(root.querySelector('[data-work-labels]').textContent);
    const content = root.querySelector('[data-work-content]');
    let current = null;
    let mode = 'photos';
    const frameHost = root.querySelector('[data-work-frame-host]');
    const replaceFrame = () => {
      frameHost.replaceChildren();
      if (mode !== 'official' || !current) return;
      const frame = document.createElement('iframe');
      frame.title = labels.frameTitle + ' — ' + current.title;
      frame.setAttribute('sandbox', 'allow-scripts allow-same-origin');
      frame.referrerPolicy = 'no-referrer';
      frame.src = current.url;
      frameHost.append(frame);
    };
    const showMode = (value) => {
      mode = value === 'official' ? 'official' : 'photos';
      root.querySelector('[data-work-photos-panel]').hidden = mode !== 'photos';
      root.querySelector('[data-work-official-panel]').hidden = mode !== 'official';
      root.querySelectorAll('[data-work-mode]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.workMode === mode)));
      replaceFrame();
    };
    const notes = [];
    const MAX_NOTES = 30;
    const notePanel = document.createElement('div');
    notePanel.style.cssText = 'margin:18px 0;padding:14px 16px;border:solid #2f7fa6;border-width:1px 1px 4px;border-radius:12px;background:#fff';
    const noteHeading = document.createElement('h3');
    noteHeading.style.cssText = 'margin:0 0 8px;font-size:1.8rem';
    const noteEmpty = document.createElement('p');
    noteEmpty.textContent = 'まだ写真が追加されていません。写真の下の「この写真を追加」を押してください。';
    noteEmpty.style.cssText = 'margin:0 0 10px;font-size:1.4rem';
    const noteList = document.createElement('ol');
    noteList.style.cssText = 'margin:0 0 10px;padding-left:2.2rem;font-size:1.4rem;line-height:1.7';
    const noteActions = document.createElement('div');
    noteActions.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px';
    const noteButton = (label, primary) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.style.cssText = 'min-height:44px;padding:0 16px;border:1px solid #005c86;border-radius:8px;font-size:1.4rem;font-weight:700;cursor:pointer;' + (primary ? 'background:#005c86;color:#fff' : 'background:#fff;color:#005c86');
      return button;
    };
    const noteUndo = noteButton('ひとつ戻す', false);
    const noteClear = noteButton('すべて外す', false);
    const noteSend = noteButton('この内容で相談する', true);
    const renderNotes = () => {
      noteHeading.textContent = '相談する写真 ' + notes.length + ' / ' + MAX_NOTES;
      noteList.replaceChildren(...notes.map((note) => {
        const li = document.createElement('li');
        li.textContent = note.title + ' 写真' + note.index + (note.text ? '：' + note.text : '');
        return li;
      }));
      noteEmpty.hidden = notes.length > 0;
      [noteUndo, noteClear, noteSend].forEach((button) => {
        button.disabled = !notes.length;
        button.style.opacity = notes.length ? '1' : '.45';
      });
    };
    const addNote = (note) => {
      if (notes.length >= MAX_NOTES) { status.textContent = '相談する写真は30件までです。'; return; }
      notes.push(note);
      renderNotes();
      status.textContent = note.title + ' 写真' + note.index + 'を追加しました。';
    };
    noteUndo.addEventListener('click', () => { notes.pop(); renderNotes(); });
    noteClear.addEventListener('click', () => { notes.length = 0; renderNotes(); });
    noteSend.addEventListener('click', () => {
      const form = document.querySelector('#AceSpaceInquiry');
      const body = form && form.querySelector('[name="contact[body]"]');
      if (!body || !notes.length) return;
      const text = '【写真ごとの相談】\n' + notes.map((note, i) => (i + 1) + '. ' + note.title + ' 写真' + note.index + '\n   ' + note.url + (note.text ? '\n   相談内容：' + note.text : '')).join('\n');
      const base = body.value.replace(/【写真ごとの相談】[\s\S]*$/, '').trimEnd();
      body.value = (base ? base + '\n\n' : '') + text;
      body.dispatchEvent(new Event('input', {bubbles: true}));
      form.scrollIntoView({behavior: 'smooth', block: 'start'});
      body.focus({preventScroll: true});
    });
    noteActions.append(noteUndo, noteClear, noteSend);
    notePanel.append(noteHeading, noteEmpty, noteList, noteActions);
    content.append(notePanel);
    renderNotes();
    const choose = (item, updateUrl = true) => {
      current = item;
      select.value = item.id;
      root.querySelector('[data-work-title]').textContent = item.title;
      const source = root.querySelector('[data-work-source]');
      source.textContent = item.url;
      source.href = item.url;
      root.querySelector('[data-work-external]').href = item.url;
      root.querySelector('[data-work-local]').href = item.pageUrl;
      const photos = root.querySelector('[data-work-photos]');
      photos.replaceChildren();
      item.photos.forEach((photo, index) => {
        const figure = document.createElement('figure');
        const image = document.createElement('img');
        image.src = photo.url;
        image.alt = photo.alt || item.title;
        image.loading = index ? 'lazy' : 'eager';
        image.decoding = 'async';
        const caption = document.createElement('figcaption');
        caption.textContent = photo.caption || item.title;
        const noteBox = document.createElement('div');
        noteBox.style.cssText = 'display:grid;gap:6px;margin:6px 0 16px';
        const noteInput = document.createElement('textarea');
        noteInput.rows = 2;
        noteInput.maxLength = 300;
        noteInput.placeholder = 'この写真について相談したいこと（空欄でも追加できます）';
        noteInput.setAttribute('aria-label', 'この写真についての相談内容');
        noteInput.style.cssText = 'width:100%;padding:8px;border:1px solid #b8d0db;border-radius:8px;font-size:1.4rem;font-family:inherit';
        const noteAdd = document.createElement('button');
        noteAdd.type = 'button';
        noteAdd.textContent = 'この写真を追加';
        noteAdd.style.cssText = 'justify-self:start;min-height:40px;padding:0 16px;border:0;border-radius:8px;background:#005c86;color:#fff;font-size:1.4rem;font-weight:700;cursor:pointer';
        noteAdd.addEventListener('click', () => {
          addNote({id: item.id, title: item.title, index: index + 1, url: photo.url, text: noteInput.value.trim()});
          noteInput.value = '';
        });
        noteBox.append(noteInput, noteAdd);
        figure.append(image, caption, noteBox);
        photos.append(figure);
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('ace_work_id', item.id);
        window.history.replaceState(window.history.state, '', url.href);
      }
      replaceFrame();
      document.dispatchEvent(new CustomEvent('ace:work-selected', {detail: {id: item.id}}));
      status.textContent = labels.ready;
    };
    try {
      const asset = new URL(root.dataset.aceWorksUrl, location.origin);
      if (asset.protocol !== 'https:' || (asset.origin !== location.origin && asset.hostname !== 'cdn.shopify.com')) throw new Error('Invalid source');
      const response = await fetch(asset.href, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Source unavailable');
      const works = normalize(await response.json());
      if (!works.length) throw new Error('No verified works');
      select.replaceChildren(...works.map((item) => { const option = document.createElement('option'); option.value = item.id; option.textContent = item.title; return option; }));
      const id = new URLSearchParams(location.search).get('ace_work_id');
      const errorContext = document.querySelector('[data-ace-inquiry-context][data-response="error"]');
      const restoredUrl = errorContext?.dataset.aceWorkRestoredUrl || errorContext?.querySelector('[data-ace-source-url]')?.value;
      const chosen = works.find((item) => item.url === restoredUrl) || works.find((item) => item.id === id) || works[0];
      select.addEventListener('change', () => { const item = works.find((entry) => entry.id === select.value); if (item) choose(item); });
      root.querySelectorAll('[data-work-mode]').forEach((button) => button.addEventListener('click', () => showMode(button.dataset.workMode)));
      root.querySelector('[data-work-reset]').addEventListener('click', replaceFrame);
      window.addEventListener('popstate', () => { const next = works.find((item) => item.id === new URLSearchParams(location.search).get('ace_work_id')); if (next) choose(next, false); });
      const gallery = document.createElement('div');
      gallery.setAttribute('role', 'group');
      gallery.setAttribute('aria-label', '写真から事例を選ぶ');
      gallery.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:8px;max-height:330px;overflow:auto;margin:12px 0 16px;padding:8px;border:1px solid #b8d0db;border-radius:9px;background:#fff';
      const markThumb = (id) => gallery.querySelectorAll('button').forEach((button) => {
        const on = button.dataset.workThumb === id;
        button.setAttribute('aria-pressed', String(on));
        button.style.borderColor = on ? '#005c86' : 'transparent';
      });
      const preview = document.createElement('div');
      preview.setAttribute('aria-hidden', 'true');
      preview.style.cssText = 'position:fixed;z-index:60;display:none;width:min(460px,60vw);padding:6px;border:2px solid #005c86;border-radius:10px;background:#fff;box-shadow:0 10px 30px rgba(0,47,68,.3);pointer-events:none';
      const previewImage = document.createElement('img');
      previewImage.alt = '';
      previewImage.style.cssText = 'display:block;width:100%;aspect-ratio:3/2;object-fit:cover;border-radius:6px';
      const previewLabel = document.createElement('p');
      previewLabel.style.cssText = 'margin:6px 4px 2px;font-size:1.4rem;font-weight:700;color:#17324d';
      preview.append(previewImage, previewLabel);
      document.body.append(preview);
      const hidePreview = () => { preview.style.display = 'none'; };
      const showPreview = (button, item) => {
        const rect = button.getBoundingClientRect();
        previewImage.src = item.photos[0].url;
        previewLabel.textContent = item.title;
        preview.style.display = 'block';
        const width = preview.offsetWidth;
        const height = preview.offsetHeight;
        let left = rect.right + 10;
        if (left + width > window.innerWidth - 8) left = rect.left - width - 10;
        if (left < 8) left = 8;
        const top = Math.max(8, Math.min(rect.top + rect.height / 2 - height / 2, window.innerHeight - height - 8));
        preview.style.left = left + 'px';
        preview.style.top = top + 'px';
      };
      gallery.addEventListener('scroll', hidePreview);
      window.addEventListener('scroll', hidePreview, {passive: true});
      works.forEach((item) => {
        const button = document.createElement('button');
        button.title = item.title;
        button.addEventListener('mouseenter', () => showPreview(button, item));
        button.addEventListener('mouseleave', hidePreview);
        button.addEventListener('focus', () => showPreview(button, item));
        button.addEventListener('blur', hidePreview);
        button.type = 'button';
        button.dataset.workThumb = item.id;
        button.style.cssText = 'display:block;padding:0;border:3px solid transparent;border-radius:8px;background:#f3fafd;color:#17324d;cursor:pointer;overflow:hidden;font-size:1.2rem;line-height:1.8';
        const image = document.createElement('img');
        image.src = item.photos[0].url;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.style.cssText = 'display:block;width:100%;aspect-ratio:3/2;object-fit:cover';
        const label = document.createElement('span');
        label.textContent = '事例 ' + item.id;
        button.append(image, label);
        button.addEventListener('click', () => choose(item));
        gallery.append(button);
      });
      content.before(gallery);
      document.addEventListener('ace:work-selected', (event) => markThumb(event.detail.id));
      select.disabled = false;
      content.hidden = false;
      root.dataset.ready = 'true';
      choose(chosen);
    } catch {
      root.dataset.ready = 'error';
      status.textContent = labels.error;
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalize};
  if (typeof document === 'undefined') return;
  const start = () => document.querySelectorAll('[data-ace-works-inquiry]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
})();
